// this contains named variables for the base tints and hues used in the other colour files.
// NOTE: These colours should never be used outside of fe-brary.
// Use colours from colour-scheme or color-atom-palette instead

export default (() => ({
  colour: {
    domainNavy400: '#22365a',
    domainNavy500: '#0b2047',
    domainNavy600: '#071939',
    rtaBlue25: '#E1F6FE',
    rtaBlue50: '#E1F6FE',
    rtaBlue100: '#B5E9FC',
    rtaBlue200: '#85DAF8',
    rtaBlue300: '#55CCF2',
    rtaBlue400: '#35C1EB',
    rtaBlue500: '#28B7E4',
    rtaBlue600: '#21A7D0',
    rtaBlue700: '#1393B5',
    rtaBlue800: '#057F9C',
    domainLobster100: '#ffcec3',
    domainLobster500: '#ff613d',
    domainLobster600: '#f74a23',
    domainCanary500: '#fc0',
    domainCanary100: '#ffefaf',
    domainTurquoise500: '#05bbb6',
    domainTurquoise100: '#ccf1f0',
    domainGrimace500: '#612b87',
    domainBlurple500: '#514aea'
  }
}));